import { useHousehold } from "./use-household"

const FALLBACK: Record<string, string> = {
  user_1: "Person 1",
  user_2: "Person 2",
  joint: "Joint",
}

export function useOwnerLabels(): Record<string, string> {
  const { data } = useHousehold()
  // Priority: explicit household.ownerLabels > the member's real name > generic
  // "Person 1/2". This stops the app showing "Person 1 / Person 2" when the
  // members already have names (#63).
  const fromMembers: Record<string, string> = {}
  for (const m of data?.members ?? []) {
    if (m.owner && m.name) fromMembers[m.owner] = m.name
  }
  return { ...FALLBACK, ...fromMembers, ...(data?.household?.ownerLabels ?? {}) }
}
